import { render, staticRenderFns } from "./edutalk-title.vue?vue&type=template&id=7f5688ae"
import script from "./edutalk-title.vue?vue&type=script&lang=js"
export * from "./edutalk-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports